import React, { useState, useEffect, useRef } from 'react';
import '../index.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { useProperty } from '../context/PropertyContext.js';
import StarRating from './StarRating.js';
import { useComment } from '../context/commentContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditComment = ({ isOpen, onClose, currentComment }) => {
  const serverUrl = 'https://osdevhub.com/homify_backend/api/properties';
  

  const {updateComment, getCommentsForProperty, commentIsLoading} = useComment();

    const navigate = useNavigate();
        const {id} = useParams()
    const {user} = useAuth();
    const user_id = user.id

  const [formData, setFormData] = useState({
    rating : currentComment?.rating || '',
    comment : currentComment?.comment || '',
  });

  useEffect(() => {
    if (currentComment) {
        setFormData({
            rating : currentComment?.rating || '',
            comment : currentComment?.comment || '',
        })
    }
  }, [currentComment])
  
console.log('current rate', formData.rating);



  const [error, setError] = useState(null);
  const modalRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault()
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
        
        data.append(key, value);
    });



    try {

      await updateComment(currentComment.id, data)
      await getCommentsForProperty(id);

        toast.success('Comment updated successfully', {
          position: "top-right",
          autoClose: 2000
      });

        setTimeout(() => {
          onClose();
        }, 3000)
      
    } catch (err) {
      console.error("Update error:", err);
      setError("Failed to update property.");
      
              toast.error('Property was not updated successfully', {
                position: "top-right",
                autoClose: 2000
            });
      
              setTimeout(() => {
                onClose();
              }, 3000)
            
    }
  };

  function handleSetRating(newRating) {
    setFormData((prevData) => ({...prevData, rating: newRating}))
    
  }


  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);




  if (!isOpen) return null;

  if(!currentComment) return null

  return (
    <div className="modal-container">
      <ToastContainer />
      <div className="userdata-modal-content" ref={modalRef}>
        <div className="add-text-header">
          <h3>Edit Comment</h3>
          <span onClick={onClose} className="close">&times;</span>
        </div>
        <div id="user-data-content-container-location" className="margin-top">
             <form className="add-review-form" onSubmit={handleSubmit}>
                <div className="rating-input">
                    <label>Rating:</label>
                    <StarRating  onSetRating={handleSetRating} defaultRating={formData.rating || currentComment.rating} />
                </div>
                <textarea name='comment' value={formData.comment} onChange={handleChange} placeholder="Leave your comment here..." />
                <div className='review-button-container'>
                    <button type="submit">
                      {commentIsLoading ? 'Updating...' : 'Update'}
                    </button>
                </div>
            </form>
        </div>
      </div>
    </div>
  );
};

export default EditComment;
